import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteVoicemailMutationVariables = Types.Exact<{
  voicemailId: Types.Scalars['Int']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type DeleteVoicemailMutation = { __typename?: 'Mutation', deleteVoicemailMessage: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', type: string }> | null } };

export type MarkVoicemailMutationVariables = Types.Exact<{
  voicemailId: Types.Scalars['Int']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type MarkVoicemailMutation = { __typename?: 'Mutation', markVoicemailMessage: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', type: string }> | null } };


export const DeleteVoicemailDocument = gql`
    mutation DeleteVoicemail($voicemailId: Int!, $userId: Int!) {
  deleteVoicemailMessage(voicemailId: $voicemailId, userId: $userId) {
    errors {
      type
    }
  }
}
    `;
export type DeleteVoicemailMutationFn = Apollo.MutationFunction<DeleteVoicemailMutation, DeleteVoicemailMutationVariables>;

/**
 * __useDeleteVoicemailMutation__
 *
 * To run a mutation, you first call `useDeleteVoicemailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoicemailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoicemailMutation, { data, loading, error }] = useDeleteVoicemailMutation({
 *   variables: {
 *      voicemailId: // value for 'voicemailId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteVoicemailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVoicemailMutation, DeleteVoicemailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVoicemailMutation, DeleteVoicemailMutationVariables>(DeleteVoicemailDocument, options);
      }
export type DeleteVoicemailMutationHookResult = ReturnType<typeof useDeleteVoicemailMutation>;
export type DeleteVoicemailMutationResult = Apollo.MutationResult<DeleteVoicemailMutation>;
export type DeleteVoicemailMutationOptions = Apollo.BaseMutationOptions<DeleteVoicemailMutation, DeleteVoicemailMutationVariables>;
export const MarkVoicemailDocument = gql`
    mutation MarkVoicemail($voicemailId: Int!, $userId: Int!) {
  markVoicemailMessage(voicemailId: $voicemailId, userId: $userId) {
    errors {
      type
    }
  }
}
    `;
export type MarkVoicemailMutationFn = Apollo.MutationFunction<MarkVoicemailMutation, MarkVoicemailMutationVariables>;

/**
 * __useMarkVoicemailMutation__
 *
 * To run a mutation, you first call `useMarkVoicemailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkVoicemailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markVoicemailMutation, { data, loading, error }] = useMarkVoicemailMutation({
 *   variables: {
 *      voicemailId: // value for 'voicemailId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMarkVoicemailMutation(baseOptions?: Apollo.MutationHookOptions<MarkVoicemailMutation, MarkVoicemailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkVoicemailMutation, MarkVoicemailMutationVariables>(MarkVoicemailDocument, options);
      }
export type MarkVoicemailMutationHookResult = ReturnType<typeof useMarkVoicemailMutation>;
export type MarkVoicemailMutationResult = Apollo.MutationResult<MarkVoicemailMutation>;
export type MarkVoicemailMutationOptions = Apollo.BaseMutationOptions<MarkVoicemailMutation, MarkVoicemailMutationVariables>;